/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconInfoSolidComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 512 512">
    <g>
    <g>
        <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256 C512,114.511,397.504,0,256,0z M282.289,357.621c0,8.088-11.794,16.174-26.284,16.174c-15.164,0-25.946-8.086-25.946-16.174 V229.234c0-9.435,10.783-15.839,25.946-15.839c14.49,0,26.284,6.404,26.284,15.839V357.621z M256.006,182.396 c-15.501,0-27.631-11.457-27.631-24.263c0-12.805,12.131-23.925,27.631-23.925c15.164,0,27.296,11.12,27.296,23.925 C283.302,170.939,271.169,182.396,256.006,182.396z" />
    </g>
</g>
  </Icon>
);
};

IconInfoSolidComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxnPgogICAgICA8cGF0aCBkPSJNMjU2LDBDMTE0LjUwOSwwLDAsMTE0LjQ5NiwwLDI1NmMwLDE0MS40ODksMTE0LjQ5NiwyNTYsMjU2LDI1NmMxNDEuNDkxLDAsMjU2LTExNC40OTYsMjU2LTI1NiBDNTEyLDExNC41MTEsMzk3LjUwNCwwLDI1NiwweiBNMjgyLjI4OSwzNTcuNjIxYzAsOC4wODgtMTEuNzk0LDE2LjE3NC0yNi4yODQsMTYuMTc0Yy0xNS4xNjQsMC0yNS45NDYtOC4wODYtMjUuOTQ2LTE2LjE3NCBWMjI5LjIzNGMwLTkuNDM1LDEwLjc4My0xNS44MzksMjUuOTQ2LTE1LjgzOWMxNC40OSwwLDI2LjI4NCw2LjQwNCwyNi4yODQsMTUuODM5VjM1Ny42MjF6IE0yNTYuMDA2LDE4Mi4zOTYgYy0xNS41MDEsMC0yNy42MzEtMTEuNDU3LTI3LjYzMS0yNC4yNjNjMC0xMi44MDUsMTIuMTMxLTIzLjkyNSwyNy42MzEtMjMuOTI1YzE1LjE2NCwwLDI3LjI5NiwxMS4xMiwyNy4yOTYsMjMuOTI1IEMyODMuMzAyLDE3MC45MzksMjcxLjE2OSwxODIuMzk2LDI1Ni4wMDYsMTgyLjM5NnoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg==";
IconInfoSolidComponent.Content = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256 C512,114.511,397.504,0,256,0z M282.289,357.621c0,8.088-11.794,16.174-26.284,16.174c-15.164,0-25.946-8.086-25.946-16.174 V229.234c0-9.435,10.783-15.839,25.946-15.839c14.49,0,26.284,6.404,26.284,15.839V357.621z M256.006,182.396 c-15.501,0-27.631-11.457-27.631-24.263c0-12.805,12.131-23.925,27.631-23.925c15.164,0,27.296,11.12,27.296,23.925 C283.302,170.939,271.169,182.396,256.006,182.396z"/>
    </g>
  </g>
</svg>`;

const IconInfoSolid = styled(IconInfoSolidComponent)``;

export default IconInfoSolid;
